import { mapStyles } from "./map_styles";
import { stores } from "./stores-data";

const loadGoogleMapsApi = require("load-google-maps-api");

const apiKey = "AIzaSyAwE73FpReh480iE4eZrnVBaG55kAc8Zag";

class MapIsoleGiro {
  constructor(elementId) {
    this.map = null;
    this.markers = {};
    this.infoWindow = null;
    this.elementId = elementId;
  }

  static loadGoogleMapsApi() {
    return loadGoogleMapsApi({ key: apiKey });
  }

  init() {
    if (this.map) return;

    MapIsoleGiro.loadGoogleMapsApi().then((googleMaps) => {
      this.map = new googleMaps.Map(document.getElementById(this.elementId), {
        center: { lat: 41.9028, lng: 12.4964 }, // Centro Italia
        zoom: 6,
        styles: mapStyles,
        disableDefaultUI: true,
        zoomControl: true,
        streetViewControl: false,
      });

      this.infoWindow = new googleMaps.InfoWindow();

      // Aggiungi tutti i marker
      stores.forEach((store) => {
        const marker = new googleMaps.Marker({
          position: store.coordinates,
          title: store.title,
          map: this.map,
          animation: google.maps.Animation.DROP,
        });

        marker.addListener("click", () => this.showInfoWindow(marker, store));
        this.markers[store.id] = marker;
      });
    });
  }

  showInfoWindow(marker, store) {
    const content = `
      <div class="store-info-window">
        <h3 class="store-title">${store.title}</h3>
        <p class="store-address">${store.address}</p>
      </div>
    `;

    this.infoWindow.setContent(content);
    this.infoWindow.open(this.map, marker);
  }
}

// Inizializzazione della mappa e gestione del modal
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("map-modal");
  const openButton = document.querySelector(".js-open-map-modal");
  const closeButton = document.querySelector(".map-modal-close");
  let map = null;

  if (openButton) {
    openButton.addEventListener("click", (e) => {
      e.preventDefault();
      modal.style.display = "block";
      document.body.style.overflow = "hidden";

      if (!map) {
        map = new MapIsoleGiro("map-isole-giro");
        map.init();
      }
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      modal.style.display = "none";
      document.body.style.overflow = "auto";
    });
  }

  window.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.style.display = "none";
      document.body.style.overflow = "auto";
    }
  });
});

export default MapIsoleGiro;
